import React from "react";
import { motion } from "framer-motion";
import mascoteSvg from "./assets/mascote.svg";

export default function Mascote({ onClick, onDoubleClick, size, animando, status }) {
  const tamanho = size === "grande" ? "w-64 h-64" : "w-40 h-40";

  // Define filtros ou estilos conforme o status
  let extraStyle = "";
  let extraClass = "";

  if (status === "fome") {
    extraStyle = "grayscale(0.5) brightness-75";
  } else if (status === "triste") {
    extraStyle = "grayscale";
  } else if (status === "sono") {
    extraStyle = "blur-[1.5px] opacity-80";
  } else if (status === "sujo") {
    extraStyle = "sepia";
  }

  // Você pode adicionar um emoji de expressão sobreposto também:
  let emoji = null;
  if (status === "fome") emoji = "🍔";
  else if (status === "triste") emoji = "😢";
  else if (status === "sono") emoji = "😴";
  else if (status === "sujo") emoji = "🛁";

  return (
    <motion.div
      className="flex flex-col items-center justify-center cursor-pointer relative"
      initial={false}
      animate={
        animando
          ? { scale: [1, 1.15, 0.95, 1.1, 1], rotate: [0, 5, -5, 0] }
          : { scale: 1, rotate: 0 }
      }
      transition={{ duration: 0.8, times: [0, 0.2, 0.5, 0.8, 1] }}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      title="Clique para interagir!"
    >
      <img
        src={mascoteSvg}
        alt="Mascote Virtual"
        className={`${tamanho} drop-shadow-lg transition-all duration-300 ${extraStyle}`}
      />
      {emoji && (
        <span className="absolute bottom-2 right-4 text-4xl pointer-events-none animate-bounce">
          {emoji}
        </span>
      )}
    </motion.div>
  );
}